import React from "react";

const Mandatory = () => {
  return <span className="mandatory ms-1">*</span>;
};

export default Mandatory;
